import { render, staticRenderFns } from "./customer-portal-document-viewer.vue?vue&type=template&id=5961156b&scoped=true&"
import script from "./customer-portal-document-viewer.vue?vue&type=script&lang=js&"
export * from "./customer-portal-document-viewer.vue?vue&type=script&lang=js&"
import style0 from "./customer-portal-document-viewer.vue?vue&type=style&index=0&id=5961156b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961156b",
  null
  
)

export default component.exports